import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { RoutePath } from '@tgbot/app/enums/route-path.enum';
import { TelegramAccountService } from '@tgbot/app/services/telegram-accout.service';
import { AccountInfoRouteData } from '@tgbot/app/types/account-info-route-data.type';
import { catchError, map, of } from 'rxjs';

export const accountInfoResolver: ResolveFn<AccountInfoRouteData['account'] | RedirectCommand> = (route) => {
  const router = inject(Router);
  const telegramService = inject(TelegramAccountService);
  const accountId = route.paramMap.get('id') ?? '';
  const noAccess = new RedirectCommand(router.createUrlTree([RoutePath.NoAccess]));

  if (!accountId) return noAccess;

  return telegramService.getAccountByAccountId(accountId).pipe(
    map((account) => account ?? noAccess),
    catchError(() => of(noAccess)),
  );
};
